/**
 * 将秒数格式化为指定规则的时间字符串
 * @param seconds 秒数
 * @returns 格式化后的字符串
 * 
 * 规则：
 *  - 小于 60 秒：显示为 "00.ss"
 *  - 小于 3600 秒（即 1 小时）：显示为 "mm.ss"
 *  - 超过 3600 秒：显示为 "h:mm:ss"
 */
export function formatAudioTime(seconds: number): string {
  if (isNaN(seconds) || seconds < 0) return "00:00";

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  // 小于 1 分钟
  if (seconds < 60) {
    return `00:${s.toString().padStart(2, '0')}`;
  }

  // 小于 1 小时
  if (seconds < 3600) {
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }

  // 大于等于 1 小时
  return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
